export default "__VITE_ASSET__d07400eb__"